<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let { headline = "", subtitle = "", buttonText = "", buttonHref = "/contact" } = $props();
</script>

<section style="padding-top:0">
  <div class="container">
    <div class="cta-section fade-up" use:observe>
      <h2>{headline}</h2>
      <p>{subtitle}</p>
      {#if buttonText}
        <a href={buttonHref} class="btn btn-primary">{buttonText}</a>
      {/if}
    </div>
  </div>
</section>
